import useAuthContext from '@salesforce/commerce-sdk-react/hooks/useAuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';
import { bffDelete } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { CustomerProductList } from './model';

export const useDeleteSaveForLater = (): UseMutationResult<
    CustomerProductList,
    unknown,
    string
> => {
    const auth = useAuthContext();
    const queryClient = useQueryClient();

    return useMutation<CustomerProductList, unknown, string>({
        mutationFn: async (productId: string) => {
            const { customer_id, access_token } = await auth.ready();

            return bffDelete(`/customers/${customer_id}/save-for-later/${productId}`, {
                accessToken: access_token,
                customerId: customer_id,
            });
        },
        onSuccess: (list: CustomerProductList): void => {
            queryClient.setQueryData([BffQueryKey.CUSTOMER_SAVE_FOR_LATER], list);
        },
    });
};
